import config from '../config'
import { authRequest } from '../request'

const base = `${config.mainApi}/client-credentials`

export type ClientCredential = {
  id: number
  clientId: string
  name: string
  role: string
  isBlocked: boolean
  createdAt: string
  updatedAt: string
}

export type ClientCredentialInput = Pick<
  ClientCredential,
  'clientId' | 'name' | 'role' | 'isBlocked'
> & {
  clientSecret?: string
}

export const listClientCredentials = (params?: Record<string, string | boolean>) =>
  authRequest.get<MISSING_TYPE, ClientCredential[]>(base, { params })

export const createClientCredential = (data: ClientCredentialInput) =>
  authRequest.post<MISSING_TYPE, ClientCredential>(base, data)

export const updateClientCredential = (id: number, data: ClientCredentialInput) =>
  authRequest.put<MISSING_TYPE, ClientCredential>(`${base}/${id}`, data)
